export enum TagOperation {
    None,
    Centroid,
    Vertex,
}

export default TagOperation;
